import { render, staticRenderFns } from "./SdkAddPersonId.vue?vue&type=template&id=0f8a6b41&"
import script from "./SdkAddPersonId.vue?vue&type=script&lang=js&"
export * from "./SdkAddPersonId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f8a6b41')) {
      api.createRecord('0f8a6b41', component.options)
    } else {
      api.reload('0f8a6b41', component.options)
    }
    module.hot.accept("./SdkAddPersonId.vue?vue&type=template&id=0f8a6b41&", function () {
      api.rerender('0f8a6b41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/SDK/SdkAddPersonId.vue"
export default component.exports